import validator from 'validator';

export default function HyperlinkTableDirective() {
  return {
    template: require('./hyperlink-table.component.html'),
    transclude: true,
    restrict: 'AE',
    scope: {
      form: '=',
      onSave: '=',
      originalObject: '=',
    },
    controller: HyperlinkTableController,
    controllerAs: 'vm',
    bindToController: true,
  };

  function HyperlinkTableController($scope, urlUtil, markdownService) {
    'ngInject';
    let vm = this;
    vm.hyperlink = {
      text: '',
      url: '',
    };
    vm.currentPage = 1;
    vm.maxTextLength = 150;
    vm.maxSize = 3;
    vm.itemsPerPage = 10;
    vm.urlPlaceholder = 'Url';
    vm.textPlaceholder = 'Display Text';
    vm.values = [];
    vm.valField = false;

    vm.validUrl = validUrl;
    vm.getListIndex = getListIndex;
    vm.add = add;
    vm.keydown = keydown;
    vm.rowErrorCount = rowErrorCount;

    vm.$onInit = () => {
      vm.onSave.invoke = function () {
        vm.originalObject.values = _.map(vm.values, convertToMarkdown);
      };
    };

    $scope.$watch(
      function () {
        return vm.values;
      },
      function () {
        vm.hyplinkForm.text.$setValidity('required', vm.values.length > 0);
        vm.hyplinkForm.url.$setValidity('required', vm.values.length > 0);
      },
      true,
    );

    $scope.$watch(
      function () {
        return vm.originalObject;
      },
      function () {
        vm.values = _.map(vm.originalObject.values, convertToModel);
      },
    );

    function convertToModel(url) {
      return markdownService.markdownToUrl(url.value);
    }

    function convertToMarkdown(url) {
      let markdown = markdownService.urlToMarkdown(url);
      return {
        value: markdown,
        attrs: {},
      };
    }

    function validUrl(url) {
      if (url) {
        return validator.isURL(url);
      }
      return false;
    }

    function getListIndex(pageIndex) {
      let listIndex = pageIndex + (vm.currentPage - 1) * vm.itemsPerPage;
      return listIndex;
    }

    function add() {
      if (vm.hyperlink.text.length === 0) {
        vm.addFailed = true;
        document.getElementById('hyperlinkDisplayText').focus();
        return;
      }
      if (vm.hyperlink.url.length === 0) {
        vm.addFailed = true;
        document.getElementById('hyperlinkTextbox').focus();
        return;
      }
      if (!vm.validUrl(vm.hyperlink.url)) {
        vm.addFailed = true;
        document.getElementById('hyperlinkTextbox').focus();
        return;
      }
      vm.hyperlink.url = urlUtil.appendDefaultProtocol(vm.hyperlink.url);
      vm.values.push(_.clone(vm.hyperlink, true));
      vm.hyperlink.text = '';
      vm.hyperlink.url = '';
      vm.addFailed = false;
      GTM_ListChanged('attributeHyperlinkValueAdded');
    }

    function keydown() {
      let keyCode = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode;
      if (keyCode === 13) {
        let e = window.event;

        e.cancelBubble = true;
        e.returnValue = false;

        if (e.stopPropagation) {
          e.stopPropagation();
          e.preventDefault();
          if (vm.valField) {
            vm.add(vm.hyperlink);
          }
        }
      }
    }

    function rowErrorCount() {
      let errorCount = 0;
      if (vm.form.$error.required) {
        for (let i = 0; i < vm.form.$error.required.length; i++) {
          let error = vm.form.$error.required[i];
          if (error.$name === 'hyperlinkForm') {
            errorCount = errorCount + 1;
          }
        }
      }
      return errorCount;
    }

    vm.pageChanged = function () {
      GTM_ListChanged('attributeHyperlinkPageChanged');
    };

    function GTM_ListChanged(event) {
      window.dataLayer.push({
        event: event,
        data: {
          total: vm.values.length,
          pageNumber: vm.currentPage,
        },
      });
    }
  }
}
